import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon.js';

function Pill(props) {
  var _a, _b;
  const pillClassName = clsx('pill', props.color ? "pill-".concat(props.color) : null, "pill-size-".concat((_a = props.size) !== null && _a !== void 0 ? _a : 'normal'), props.circle ? 'border-circle p-1' : null, props.onDismiss ? 'pill-dismissible' : null, props.className);
  const transformedChildren = typeof props.children === 'string' ? props.children.toUpperCase() : props.children;
  function handleDismiss(event) {
    var _a;
    event.preventDefault();
    event.stopPropagation();
    (_a = props.onDismiss) === null || _a === void 0 ? void 0 : _a.call(props, event);
  }
  return jsxs("div", {
    id: props.id,
    className: pillClassName,
    children: [transformedChildren, props.onDismiss && jsx("button", {
      type: "button",
      className: "pill-dismiss",
      "aria-label": (_b = props.dismissAriaLabel) !== null && _b !== void 0 ? _b : 'Remove',
      onClick: handleDismiss,
      children: jsx(Icon, {
        name: "cancel"
      })
    })]
  });
}

export { Pill };
